export const LOGOUT_REASON_STATE_KEY = 'logoutReason';

export enum LogoutReason {
  Idle = 'idle',
  SessionRevoked = 'session_revoked',
  SessionExpired = 'session_expired',
}

const LOGOUT_REASON_MESSAGES: Record<LogoutReason, string> = {
  [LogoutReason.Idle]: 'idle_session.logged_out',
  [LogoutReason.SessionRevoked]: 'session_revoked.logged_out',
  [LogoutReason.SessionExpired]: 'session_expired.logged_out',
};

export function isLogoutReason(value: unknown): value is LogoutReason {
  return typeof value === 'string' && (Object.values(LogoutReason) as string[]).includes(value);
}

export function logoutReasonMessage(value: unknown): string | null {
  return isLogoutReason(value) ? LOGOUT_REASON_MESSAGES[value] : null;
}
